import { render, staticRenderFns } from "./PobOrderDetails.vue?vue&type=template&id=b01565f4&scoped=true&"
import script from "./PobOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PobOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./PobOrderDetails.vue?vue&type=style&index=0&id=b01565f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01565f4",
  null
  
)

export default component.exports